import { css } from 'styled-components'

export const brandPalette = {
  ink: '#182F35',
  limestone: '#F4F1E9',
  chalk: '#FFFFFF',
  seaGlass: '#B5C6C1',
  brass: '#A47B4F',
}

// Retain the existing semantic names so established page layouts keep working.
// Sea glass supports fills and small text on ink; brass is a decorative accent.
export const warmPalette = {
  primary: brandPalette.ink,
  primaryDark: brandPalette.ink,
  secondary: brandPalette.seaGlass,
  textAccent: brandPalette.ink,
  tertiary: brandPalette.seaGlass,
  neutralLight: brandPalette.limestone,
  contrast: brandPalette.ink,
  secondContrast: brandPalette.seaGlass,
}

export const coolPalette = {
  primary: brandPalette.ink,
  secondary: brandPalette.ink,
  tertiary: brandPalette.seaGlass,
  neutralLight: brandPalette.limestone,
  contrast: brandPalette.ink,
}

export const neutralPalette = {
  black: brandPalette.ink,
  greyDark: brandPalette.ink,
  greyLight: brandPalette.seaGlass,
  white: brandPalette.chalk,
}

// Place selection is an established map cue, independent of the brand palette.
export const mapPalette = { place: '#075D78', selectedPlace: '#083B4C' }

export const surfConditionPalette = {
  potential: { colour: '#47775D', background: '#E6EEE8' },
  less: { colour: '#A47B35', background: '#F3EDDE' },
  danger: { colour: '#B34236', background: '#F8E8E5' },
  unconfirmed: { colour: '#8D9B9E', background: '#EDF0F0' },
}

export const colorsByPosition = {
  background: brandPalette.limestone,
  mainFont: neutralPalette.black,
  fontWhite: neutralPalette.white,
  fontBlack: neutralPalette.black,
}

export const bgColor = css`
  background: ${({ bg }) =>
    bg === 'primary' ? warmPalette.primary :
    bg === 'secondary' ? warmPalette.secondary :
    bg === 'tertiary' ? warmPalette.tertiary :
    bg === 'neutral' ? warmPalette.neutralLight :
    bg === 'contrast' ? warmPalette.contrast : colorsByPosition.background};
`

export const theme = {
  colors: {
    brand: brandPalette,
    warm: warmPalette,
    cool: coolPalette,
    neutral: neutralPalette,
    position: colorsByPosition,
  },
}

export const primary = warmPalette.primary
export const secondary = brandPalette.ink
export const tertiary = brandPalette.ink
export const contrast = warmPalette.contrast
export const bg_color = colorsByPosition.background
export const font_black = neutralPalette.black
export const font_white = neutralPalette.white
export const darkGrey = neutralPalette.greyDark
export const black = neutralPalette.black
export const white = neutralPalette.white
